import { getPageType } from '~/events/utils/pageType'
import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'
import productTransformer from './transformers/product.transformer'

eventBus.$on(eventDefinitions.PRODUCT.IMPRESSION, ({ product }) => {
  const transformedProduct = productTransformer(product, 1)

  if (!transformedProduct) {
    return
  }

  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'item_impression',
    ecommerce: {
      currency: 'CZK',
      mkt_val_all: transformedProduct.mkt_val,
      page_type: getPageType(),
      items: [transformedProduct],
      google_tag_params: {
        ecomm_pagetype: getPageType(),
        ecomm_prodid: [String(transformedProduct.item_id)],
        ecomm_totalvalue: transformedProduct.price,
        ecomm_totalvalue_all: [transformedProduct.price],
      },
    },
  })
})
